(function() {
  "use strict";

  angular.module("pub.odds.service", []).factory("OddsService", OddsService);

  /** @ngInject */
  function OddsService($http, $q, API) {
    function getCollectible() {
      var defered = $q.defer();

      $http.get(API.API_URL + "publisher/collectibles").success(defered.resolve);

      return defered.promise;
    }

    function get(parentId) {
      var defered = $q.defer();

      $http
        .get(API.API_URL + "publisher/bundles/" + parentId + "/collectible_odds")
        .success(defered.resolve);

      return defered.promise;
    }

    function save(id, item) {
      var defered = $q.defer();

      $http
        .post(API.API_URL + "publisher/bundles/" + id + "/collectible_odds", item)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function update(item) {
      var defered = $q.defer();

      $http
        .post(
          API.API_URL +
            "publisher/bundles/" +
            item["id-b"] +
            "/collectible_odds/" +
            item.id,
          item
        )
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function updateBatch(id, item) {
      var defered = $q.defer();

      $http
        .put(API.API_URL + "publisher/bundles/" + id + "/collectible_odds", item)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    function deleteOdd(id) {
      var defered = $q.defer();

      $http
        .delete(API.API_URL + "publisher/collectible_odds/" + id)
        .success(defered.resolve)
        .error(defered.reject);

      return defered.promise;
    }

    return {
      get: get,
      getCollectible: getCollectible,
      save: save,
      update: update,
      updateBatch: updateBatch,
      deleteOdd: deleteOdd
    };
  }
})();
